import FilesPage from 'views/files/FilesPage';
import { Route } from '../ProtectedRoute';

const filesRoutes: Route[] = [
    {
        path: 'shared-files',
        name: 'Shared Files',
        element: <FilesPage />,
    },
];

export default filesRoutes;
